import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState, useCallback } from "react";
import useObserver from "./useObserver";
/**
 * useInView
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */

var useInView = function useInView() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      root = _ref.root,
      rootMargin = _ref.rootMargin,
      threshold = _ref.threshold,
      unobserveOnEnter = _ref.unobserveOnEnter,
      target = _ref.target,
      onEnter = _ref.onEnter,
      onLeave = _ref.onLeave,
      defaultInView = _ref.defaultInView;

  var externalState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _useState = useState({
    inView: defaultInView || false,
    entry: null,
    observer: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var callback = useCallback(function (_ref2, observer) {
    var _ref3 = _slicedToArray(_ref2, 1),
        entry = _ref3[0];

    var inThreshold = observer.thresholds.some(function (t) {
      return entry.intersectionRatio >= t;
    });
    var inView = inThreshold && entry.isIntersecting;
    setState({
      inView: inView,
      entry: entry,
      observer: observer
    }); // unobserveOnEnter

    if (inView && unobserveOnEnter) {
      observer.unobserve(entry.target);
      observer.disconnect();
    } // Legacy callbacks


    if (inView) {
      onEnter === null || onEnter === void 0 ? void 0 : onEnter(entry, observer);
    } else {
      onLeave === null || onLeave === void 0 ? void 0 : onLeave(entry, observer);
    }
  }, [onEnter, onLeave, unobserveOnEnter]);
  var setTarget = useObserver(callback, {
    root: root,
    rootMargin: rootMargin,
    threshold: threshold
  }, [unobserveOnEnter].concat(_toConsumableArray(externalState))); // Legacy 'target' option

  useEffect(function () {
    if (target === null || target === void 0 ? void 0 : target.current) setTarget(target.current);
  }, [target, setTarget]);
  return [setTarget, state.inView, state.entry, state.observer];
};

export default useInView;